import AdAnalyticsModel from "../models/ad.analytics.model";
import { AdAnalyticsType } from "../types/ad.analytics";
import { useReducerAsState } from "./useReducerAsState"

interface State {
    loadingAnalyticsGroup : boolean;
    errorAnalyticsGroup: string;
}

const useAdAnalytics = () => {
    const [state, setState] = useReducerAsState<State>({
        loadingAnalyticsGroup: false,
        errorAnalyticsGroup: "",
    })

    const { loadingAnalyticsGroup } = state

    const getAnalyticsGroup = async (itemId: number, position: string, filter: string): Promise<AdAnalyticsType | null> => {
        setState({errorAnalyticsGroup:"", loadingAnalyticsGroup: true})
        const response = await AdAnalyticsModel.find({
            groupId: itemId,
            position,
            filter
        });
        if(response.error){
            setState({errorAnalyticsGroup: response.error, loadingAnalyticsGroup: false})
            return null
        }

        setState({errorAnalyticsGroup: "", loadingAnalyticsGroup: false })
        return response.data ?? null
    }

    

    return {
        loadingAnalyticsGroup,
        getAnalyticsGroup,
    }
}

export default useAdAnalytics